<!-- Aba "Nova venda": cria uma nota com fatura legal de venda para o cliente. -->

<!-- Carregando -->
<div *ngIf="carregando" class="form-card">
  <div class="card-content">
    <div class="estado-inline">
      <i class="pi pi-spinner pi-spin"></i>
      <span>{{ 'contador_operar.venda.carregando' | translate }}</span>
    </div>
  </div>
</div>

<!-- Erro -->
<div *ngIf="!carregando && erro" class="form-card">
  <div class="card-content">
    <div class="estado-vazio">
      <i class="pi pi-exclamation-triangle estado-erro-icon"></i>
      <p>{{ 'contador_operar.venda.erro_carregar' | translate }}</p>
      <button pButton
        [label]="'contador.dashboard.estados.tentar_novamente' | translate"
        icon="pi pi-refresh"
        class="btn-primary btn-sm"
        (click)="recarregar()">
      </button>
    </div>
  </div>
</div>

<!-- Sem timbrado: não é possível emitir fatura legal -->
<div *ngIf="!carregando && !erro && timbrados.length === 0" class="form-card">
  <div class="card-content">
    <div class="estado-vazio">
      <i class="pi pi-info-circle"></i>
      <p>{{ 'contador_operar.venda.sem_timbrado' | translate }}</p>
    </div>
  </div>
</div>

<!-- Formulário -->
<ng-container *ngIf="!carregando && !erro && timbrados.length > 0">

  <!-- =============== Card: Dados da venda =============== -->
  <div class="form-card">
    <div class="card-header">
      <div class="card-header-icon">
        <i class="pi pi-file-edit"></i>
      </div>
      <span class="card-header-title">{{ 'contador_operar.venda.card_dados' | translate }}</span>
    </div>
    <div class="card-content">
      <div class="venda-grid">
        <!-- Comprador (cliente da venda). O cadastro rápido vive SÓ no rodapé do
             dropdown ("⊕ Adicionar Pessoa", via `showAddInDropdown`) — que é o
             momento em que ele faz sentido: o operador está procurando o cliente
             e não acha.
             ⚠️ NÃO repor um link "Novo cliente" ao lado do rótulo (como em
             `/vendas`): aqui os campos vivem num grid de 3 colunas, e o link
             ficava flutuando entre "Cliente" e "Vendedor", desalinhado dos
             demais rótulos. Sem os atalhos F3/F9 pelo mesmo motivo de sempre —
             são teclas de operador treinado, e aqui opera o contador. -->
        <div class="form-item">
          <label>{{ 'contador_operar.venda.comprador' | translate }} <span class="obrigatorio">*</span></label>
          <!-- Banana-box expandida de propósito: além de gravar o valor,
               precisamos do efeito colateral (revalidar o cadastro do cliente).
               `(addNew)` é o que faz o rodapé do dropdown FUNCIONAR — sem ele o
               item aparece e o clique não faz nada. -->
          <app-entity-selector
            [config]="clienteSelectorConfig"
            [value]="comprador"
            (valueChange)="onCompradorSelecionado($event)"
            (addNew)="abrirDialogNovoCliente()">
          </app-entity-selector>
          <!-- Avisa já na SELEÇÃO, antes de o usuário montar a venda inteira. -->
          <small *ngIf="camposFaltantesComprador.length > 0" class="venda-hint-incompleto">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ 'contador_operar.venda.cliente_incompleto' | translate:{ campos: textoCamposFaltantes } }}</span>
          </small>
        </div>

        <!-- Vendedor: usuários da empresa do cliente + o contador -->
        <div class="form-item">
          <label>{{ 'contador_operar.venda.vendedor' | translate }} <span class="obrigatorio">*</span></label>
          <p-dropdown
            [options]="vendedores"
            [(ngModel)]="vendedorSelecionadoId"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            styleClass="w-full"
            [placeholder]="'contador_operar.venda.vendedor_placeholder' | translate"
            [emptyMessage]="'contador_operar.venda.sem_vendedor' | translate">
          </p-dropdown>
        </div>

        <!-- Timbrado -->
        <div class="form-item">
          <label>{{ 'contador_operar.venda.timbrado' | translate }} <span class="obrigatorio">*</span></label>
          <p-dropdown
            [options]="timbrados"
            [(ngModel)]="timbradoSelecionadoId"
            optionLabel="label"
            optionValue="id"
            appendTo="body"
            styleClass="w-full"
            [placeholder]="'contador_operar.venda.timbrado_placeholder' | translate">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <!-- Duas colunas: "Itens da venda" (65%) e "Pagamento" (35%).
       Empilham abaixo de 1700px — e o breakpoint NÃO é cosmético: a faixa de
       lançamento tem 555px de campos com largura FIXA (Qtd./Preço/Subtotal/+),
       então o campo de busca vale sempre "largura do card − 597px". O placeholder
       do campo pede 378px de input, o que exige card ≥ 975px; abaixo de 1700px a
       coluna de 65% não entrega isso e o texto começa a ser cortado (medido:
       371px em 1601px e 218px em 1366px). A media query da própria faixa
       (operar-venda-linha.component.scss:169) é por VIEWPORT e não protege este
       caso — ver o comentário do @media no SCSS.
       "Dados da venda" fica de fora, em largura total. -->
  <div class="venda-colunas">

    <!-- =============== Card: Itens =============== -->
    <div class="venda-col-itens">
      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-shopping-cart"></i>
          </div>
          <span class="card-header-title">{{ 'contador_operar.venda.card_itens' | translate }}</span>
        </div>
        <div class="card-content">
          <!-- Busca inline: o operador digita o nome, o código ou passa o leitor de
               código de barras e confirma com Enter, sem abrir modal a cada item.
               A lupa dentro do campo (e o rodapé "Ver lista completa" do dropdown)
               continuam abrindo o modal de sempre.
               `cfgMoeda` vem DAQUI de propósito: é a moeda do CLIENTE, resolvida em
               carregarConfig(). Derivá-la da sessão traria a moeda do CONTADOR e já
               causou preço 100x maior em USD. Como este bloco vive dentro do
               *ngIf="!carregando ...", a moeda já está resolvida quando a tag existe
               — mover a tag para fora do ng-container reintroduziria o bug. -->
          <!-- O rótulo mora AQUI, e não dentro do filho, para reusar o
               `.form-item > label` dos demais campos da aba (Comprador, Vendedor,
               Timbrado) — este era o único campo da tela sem rótulo, contando só
               com o placeholder, que some assim que o operador digita. O `for`
               casa com o [inputId] repassado ao <input> interno do p-autoComplete. -->
          <!-- =============== Linha de lançamento ===============
               Componente próprio: o estado da COMPOSIÇÃO (item, quantidade, preço
               efetivo e a pendência de edição) mora lá dentro. Aqui ficam o
               carrinho, a regra de negócio e a gravação da nota.
               `cfgMoeda` vem DAQUI de propósito: é a moeda do CLIENTE, resolvida em
               carregarConfig(). Derivá-la da sessão traria a do CONTADOR e já
               causou preço 100x maior em USD (f106908d). -->
          <app-operar-venda-linha
            [cfgMoeda]="cfgMoeda"
            [disabled]="salvando"
            (lancar)="onItemDoModal($event)"
            (precoAusente)="abrirModalComItem($event)"
            (devolverAoCarrinho)="restaurarLinhaNoCarrinho($event)"
            (abrirLista)="abrirSelecionarItem()"
            (criarItem)="abrirCriarItem()">
          </app-operar-venda-linha>

          <!-- Cadastro rápido de CLIENTE: o MESMO diálogo de /vendas
               (`app-pessoa-adicionar-dialog`, `tipo="cliente"`), sem alteração
               nenhuma nele — ele tem outros consumidores.
               `(pessoaVinculada)` cobre o caso de o RUC digitado já existir: o
               diálogo devolve a pessoa achada em vez de criar outra. Os dois
               caminhos caem no MESMO handler, que reusa a seleção normal e, com
               ela, a validação de cadastro incompleto desta tela. -->
          <app-pessoa-adicionar-dialog
            [(visible)]="mostrarDialogNovoCliente"
            tipo="cliente"
            (pessoaCriada)="onClienteCriado($event)"
            (pessoaVinculada)="onClienteCriado($event)">
          </app-pessoa-adicionar-dialog>

          <!-- Cadastro rápido de item: o MESMO diálogo de /adicionar-compra
               (shared/components/item-criar-rapido), aqui SEM fornecedor. O item
               nasce com preço 0, então o `(criado)` encadeia para o modal de
               seleção, onde o preço é informado antes de entrar no carrinho. -->
          <app-item-criar-rapido
            [(visible)]="mostrarCriarItem"
            (criado)="onItemCriado($event)">
          </app-item-criar-rapido>

          <!-- Popup "Seleccionar Artículo" da venda: mesma cara do da compra (busca +
               tabela paginada), mas com quantidade + preço de venda. Busca os itens
               do cliente sob contexto. -->
          <app-operar-venda-item-selector *ngIf="mostrarSelecionarItem"
            [cfgMoeda]="cfgMoeda"
            (visibleChange)="mostrarSelecionarItem = $event"
            (selecionado)="onItemDoModal($event)">
          </app-operar-venda-item-selector>

          <!-- A cotação do cliente, quando não cadastrada, é solicitada pelo
               CotacaoGuardService (diálogo global) ao registrar a venda. -->

          <!-- Completar o cadastro do cliente (RUC/CI, telefone e cidade) sem sair da
               venda. Componente SEMPRE no
               DOM, [(visivel)] banana-box e um @Output de sucesso que o pai transforma
               em retry da venda.
               `camposFaltantes` serve só para o DESTAQUE visual dos grupos — a
               validação do diálogo é própria e independente. -->
          <app-operar-venda-completar-cliente
            [(visivel)]="mostrarCompletarCliente"
            [pessoaId]="comprador?.id ?? null"
            [camposFaltantes]="camposFaltantesComprador"
            [nomeCliente]="comprador?.nome ?? ''"
            (clienteAtualizado)="onClienteAtualizado($event)">
          </app-operar-venda-completar-cliente>

          <!-- Vazio: nenhum item ainda -->
          <div *ngIf="carrinho.length === 0" class="venda-carrinho-vazio">
            <i class="pi pi-shopping-cart"></i>
            <span>{{ 'contador_operar.venda.carrinho_vazio' | translate }}</span>
          </div>

          <!-- responsiveLayout="stack": abaixo do breakpoint o PrimeNG esconde o
               <thead> e empilha as células, revelando o `.p-column-title` de cada
               uma (a media query dele é injetada FORA do @layer do tema, então
               funciona sem CSS nosso). Os rótulos são texto real no DOM — legíveis
               por leitor de tela e traduzíveis, ao contrário de um `content:
               attr(data-label)`. -->
          <p-table [value]="carrinho" styleClass="p-datatable-sm venda-tabela"
            responsiveLayout="stack" [breakpoint]="'768px'" *ngIf="carrinho.length > 0">
            <ng-template pTemplate="header">
              <tr>
                <!-- As classes por COLUNA (col-qtd/col-preco/col-subtotal) existem
                     só para as larguras do desktop: sem elas nenhuma coluna tinha
                     largura declarada além da de ação, e o `table-layout: auto`
                     espalhava a sobra igualmente, abrindo um vão entre Qtd. e Preço
                     unit. As larguras vivem numa @media (min-width: 769px) — abaixo
                     disso o cartão empilhado ignora larguras. -->
                <th>{{ 'contador_operar.venda.col_item' | translate }}</th>
                <th class="col-num col-qtd">{{ 'contador_operar.venda.col_qtd' | translate }}</th>
                <th class="col-num col-preco">{{ 'contador_operar.venda.col_preco' | translate }}</th>
                <th class="col-num col-subtotal">{{ 'contador_operar.venda.col_subtotal' | translate }}</th>
                <th class="col-acao"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr>
                <td>
                  <!-- Rótulos do modo empilhado (< 768px). Escondidos no desktop
                       pelo CSS base do PrimeNG; reusam as MESMAS chaves do <thead>. -->
                  <span class="p-column-title">{{ 'contador_operar.venda.col_item' | translate }}</span>
                  <!-- O `&nbsp;` e proposital: o Angular compila com
                       `preserveWhitespaces: false` e remove o espaco entre os dois
                       <span>, o que deixava nome e codigo colados ("Coca Cola Zero402").
                       Sem codigo cadastrado o *ngIf nao renderiza nada e sobra so o nome. -->
                  <div class="cel-item">
                    <span class="cel-item-nome">{{ item.nome }}</span>
                    <span *ngIf="item.codigoItem" class="cel-item-cod">&nbsp;{{ 'contador_operar.venda.item_codigo' | translate:{ codigo: item.codigoItem } }}</span>
                  </div>
                </td>
                <td class="col-num col-qtd">
                  <span class="p-column-title">{{ 'contador_operar.venda.col_qtd' | translate }}</span>
                  <!-- Somente exibicao, igual a Preco unit. e Subtotal: a quantidade
                       e decidida na LINHA DE LANCAMENTO, antes de lancar. Depois de
                       lancado o item, a grade inteira e so leitura e a unica acao da
                       linha e a lixeira.
                       Para corrigir a quantidade ha dois caminhos: lancar o mesmo
                       item de novo (que SOMA, ver onItemDoModal) ou remover a linha
                       e lancar outra vez. -->
                  {{ item.quantidade | number: '1.0-3' : cfgMoeda.locale }}
                </td>
                <td class="col-num col-preco">
                  <span class="p-column-title">{{ 'contador_operar.venda.col_preco' | translate }}</span>
                  <!-- Preço unitário é o do item cadastrado — apenas exibido, NÃO
                       editável (o funcionário não altera o valor de venda). -->
                  {{ item.valorUnitario | moedaSimbolo: cfgMoeda.symbol : cfgMoeda.digits : cfgMoeda.locale }}
                </td>
                <td class="col-num col-subtotal cel-subtotal">
                  <span class="p-column-title">{{ 'contador_operar.venda.col_subtotal' | translate }}</span>
                  {{ subtotalItem(item) | moedaSimbolo: cfgMoeda.symbol : cfgMoeda.digits : cfgMoeda.locale }}
                </td>
                <!-- Duas ações, ambas "text" (sem fundo) para não competirem com o
                     + da faixa de lançamento, que é a ação primária da tela.
                     Editar DEVOLVE a linha à faixa: ela sai da grade e volta a ser
                     uma composição — ver `editarLinha()`. -->
                <td class="col-acao">
                  <button pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text venda-btn-editar"
                    [attr.aria-label]="'contador_operar.venda.editar' | translate"
                    [pTooltip]="'contador_operar.venda.editar' | translate"
                    tooltipPosition="top"
                    (click)="editarLinha(i)">
                  </button>
                  <button pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger"
                    [attr.aria-label]="'contador_operar.venda.remover' | translate"
                    [pTooltip]="'contador_operar.venda.remover' | translate"
                    tooltipPosition="top"
                    (click)="removerItem(i)">
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Rodapé do carrinho. O contador de itens fica à ESQUERDA (margin-right
               auto no SCSS) e o valor é ancorado sob a coluna Subtotal, para o
               Total ler como a soma daquela coluna e não como um número solto no
               canto do card.
               O ternário evita "1 itens": o ngx-translate não tem regra de plural,
               então são duas chaves — mesmo caminho já usado em outras telas. -->
          <div *ngIf="carrinho.length > 0" class="venda-total">
            <span class="venda-total-itens">
              {{ (carrinho.length === 1
                    ? 'contador_operar.venda.total_itens_um'
                    : 'contador_operar.venda.total_itens_varios') | translate: { qtd: carrinho.length } }}
            </span>
            <span class="venda-total-label">{{ 'contador_operar.venda.total' | translate }}</span>
            <span class="venda-total-valor">
              {{ total() | moedaSimbolo: cfgMoeda.symbol : cfgMoeda.digits : cfgMoeda.locale }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- =============== Card: Pagamento =============== -->
    <div class="venda-col-pago">
      <div class="form-card">
        <div class="card-header">
          <div class="card-header-icon">
            <i class="pi pi-wallet"></i>
          </div>
          <span class="card-header-title">{{ 'contador_operar.venda.card_pagamento' | translate }}</span>
        </div>
        <div class="card-content">
          <div class="venda-grid">
            <div class="form-item">
              <label>{{ 'contador_operar.venda.pagamento' | translate }}</label>
              <div class="venda-radios">
                <div class="venda-radio">
                  <p-radioButton name="pgto" value="CONTADO" [(ngModel)]="condicaoPagamento" inputId="pgtoContado"></p-radioButton>
                  <label for="pgtoContado">{{ 'contador_operar.venda.contado' | translate }}</label>
                </div>
                <div class="venda-radio">
                  <p-radioButton name="pgto" value="CREDITO" [(ngModel)]="condicaoPagamento" inputId="pgtoCredito"></p-radioButton>
                  <label for="pgtoCredito">{{ 'contador_operar.venda.credito' | translate }}</label>
                </div>
              </div>
            </div>

            <div class="form-item" *ngIf="condicaoPagamento === 'CREDITO'">
              <label>{{ 'contador_operar.venda.parcelas' | translate }}</label>
              <p-inputNumber
                [(ngModel)]="numeroParcelas"
                [min]="1"
                [showButtons]="true"
                buttonLayout="horizontal"
                decrementButtonClass="p-button-secondary"
                incrementButtonClass="p-button-secondary"
                incrementButtonIcon="pi pi-plus"
                decrementButtonIcon="pi pi-minus"
                styleClass="w-full venda-stepper venda-stepper--parcelas">
              </p-inputNumber>
            </div>
          </div>

          <div class="form-item">
            <label>{{ 'contador_operar.venda.observacao' | translate }}</label>
            <textarea pInputTextarea
              [(ngModel)]="observacao"
              rows="2"
              class="w-full"
              [placeholder]="'contador_operar.venda.observacao_placeholder' | translate">
            </textarea>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- /.venda-colunas -->

  <!-- Ações -->
  <div class="venda-acoes">
    <button pButton
      type="button"
      class="btn-primary"
      [icon]="salvando ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
      [label]="'contador_operar.venda.salvar' | translate"
      [disabled]="salvando"
      (click)="salvar()">
    </button>
  </div>

</ng-container>
